// src/services/feedbackService.js
import apiClient from './apiClient';

const feedbackService = {
  // Enviar un formulario de queja o sugerencia
  submitFeedback: async (feedbackData) => {
    try {
      console.log('Submitting feedback:', JSON.stringify(feedbackData, null, 2));
      
      // Formatear los datos para el backend
      const formattedData = {
        email: feedbackData.email,
        message: feedbackData.comentario || feedbackData.message,
        type: feedbackData.tipo || feedbackData.type,
        status: 'Pendiente'
      };
      
      const response = await apiClient.post('/forms/', formattedData);
      console.log('Feedback submitted response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error submitting feedback:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener el primer formulario pendiente (para administradores)
  getFirstPendingForm: async () => {
    try {
      const response = await apiClient.get('/forms/pending');
      return response.data;
    } catch (error) {
      console.error('Error getting pending form:', error);
      throw error;
    }
  },

  // Agregar mensaje a un formulario (para administradores)
  addMessageToForm: async (formId, message) => {
    try {
      console.log('Adding message to form:', formId, message);
      const response = await apiClient.get(`/forms/addMessage?id=${formId}`, {
        data: { message }
      });
      console.log('Message added response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error adding message to form ${formId}:`, error);
      throw error;
    }
  },

  // Finalizar un formulario (para administradores)
  finalizeForm: async (formId, finalMessage = '') => {
    try {
      console.log('Finalizing form:', formId);
      const response = await apiClient.get(`/forms/finalizeForm?id=${formId}`, {
        data: { finalMessage }
      });
      console.log('Form finalized response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error finalizing form ${formId}:`, error);
      throw error;
    }
  },

  // Obtener todos los formularios (para administradores)
  getAllForms: async () => {
    try {
      const response = await apiClient.get('/forms/getAllForms');
      return response.data;
    } catch (error) {
      console.error('Error getting all forms:', error);
      throw error;
    }
  },

  // Obtener un formulario específico por ID
  getFormById: async (formId) => {
    try {
      const response = await apiClient.get(`/forms/${formId}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting form ${formId}:`, error);
      throw error;
    }
  },

  // Obtener formularios por email de usuario
  getFormsByEmail: async (email) => {
    try {
      const response = await apiClient.get(`/forms/getAllForms`);
      // Filtrar por email en el frontend ya que no existe endpoint específico
      const allForms = response.data;
      return allForms.filter(form => form.email === email);
    } catch (error) {
      console.error(`Error getting forms for email ${email}:`, error);
      throw error;
    }
  },

  // Obtener estadísticas de formularios (para administradores)
  getFormsStats: async () => {
    try {
      const response = await apiClient.get('/forms/getAllForms');
      const forms = response.data;
      
      return {
        total: forms.length,
        pending: forms.filter(f => f.status === 'Pendiente').length,
        active: forms.filter(f => f.status === 'Activo').length,
        finalized: forms.filter(f => f.status === 'Finalizado').length,
        suggestions: forms.filter(f => f.type === 'Sugerencias' || f.type === 'Sugerencia').length,
        complaints: forms.filter(f => f.type === 'Queja' || f.type === 'Quejas').length
      };
    } catch (error) {
      console.error('Error getting forms stats:', error);
      throw error;
    }
  }
};

export default feedbackService;